var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-checkbox-input__wrapper"},[_c('input',{staticClass:"ui-radio-input",attrs:{"id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"click":_vm.handleClick}}),_c('label',{attrs:{"for":_vm.id}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }